export enum AddressEndpoint {
  Base = '/addresses',
  Page = '/page',
  Exports = '/exports',
  Extended = '/extended',
  Gates = '/gates',
}
